// extracted by mini-css-extract-plugin
module.exports = {"row":"Meta-module__row--1KP21","taxYear":"Meta-module__taxYear--3OCAx","budgetMax":"Meta-module__budgetMax--163_V"};